// components/home/CallToAction/styles.js

import styled from "styled-components";
import { Container } from "../../../styles/components";

export const CTAWrapper = styled.section`
	padding: ${(props) => `${props.theme.spacing["4xl"]} 0`};
	background: ${(props) => props.theme.colors.primary.main}08;
`;

export const CTAContainer = styled(Container)`
	text-align: center;
	max-width: 800px;
`;

export const CTATitle = styled.h2`
	font-size: ${(props) => props.theme.typography.sizes["3xl"]};
	font-weight: ${(props) => props.theme.typography.weights.bold};
	margin-bottom: ${(props) => props.theme.spacing.lg};
	color: ${(props) => props.theme.colors.text.primary};
`;

export const CTAText = styled.p`
	font-size: ${(props) => props.theme.typography.sizes.lg};
	color: ${(props) => props.theme.colors.text.secondary};
	margin-bottom: ${(props) => props.theme.spacing.xl};
`;


